module.exports = __webpack_public_path__ + "static/img/footer.6ea7f54.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/footer.png
// module id = or/K
// module chunks = 8